import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { Tournament } from '../../../types/MTT';
import BaseHeader from '../../Modal/BaseHeader/BaseHeader';
import Sidecar from '../Sidecar';

import { TXTCLI_Tournament_Information } from './SidecarModal.messages.json';
import styles from './SidecarModal.scss';

interface SidecarModalParams {
  tournament: Tournament;
  isTournamentFavorite?: boolean;
  satellites?: Tournament[];
  satellitesModalPath?: string;
  handleRemoveFavorites?: () => void;
  widgetId?: string;
}

const SidecarModal: React.FC<SidecarModalParams> = ({
  tournament,
  satellites,
  satellitesModalPath,
  isTournamentFavorite = false,
  handleRemoveFavorites,
  widgetId
}) => (
  <div className={styles.container}>
    <BaseHeader
      headerClassName={styles.title}
      title={<Translation {...TXTCLI_Tournament_Information} />}
    />
    {!!tournament && (
      <Sidecar
        tournament={tournament}
        buttonsSize="large"
        classes={{
          buttonsRoot: styles.stickyButtons,
          infoContainer: styles.infoContainer,
          card: styles.card,
          root: styles.content
        }}
        satellitesModalPath={satellitesModalPath}
        satellites={satellites}
        isTournamentFavorite={isTournamentFavorite}
        handleRemoveFavorites={handleRemoveFavorites}
        widgetId={widgetId}
      />
    )}
  </div>
);

export default SidecarModal;
